import React from "react";

import { useState, useContext } from "react";

import axios from '../../../../config/axios';

import {
    Container,
    CloseDiv,
    HeaderDiv,
    CloseImg,
    GridContainer,
    HeaderText,
    Input,
    InputDiv,
    InputLabel,
    OptionsDiv,
    ButtonOfSection,
    ButtonOfSectionText,
    PlusImg,
    LineDiv
} from './style'
import cross from '../../../../assets/orders/cross.svg'
import plus from '../../../../assets/headers/plus.svg'
import { elementsCEP } from "./utils";
import ModalContext from "../../../../contexts/ModalContext";
import { IconImg } from "../../freightContent/freightDetail/style";

export interface ClientInterface {
    cep: string,
    street: string,
    state: string,
    city: string,
    neighborhood: string,
    number: string,
    complement: string,
    days: string,
    hours: string,
    name: string
}

const ClientForm = () => {
    const { setModalActive } = useContext(ModalContext)
    const [formData, setFormData] = useState(
        {
            cep: '',
            number: '',
            street: '',
            state: '',
            city: '',
            neighborhood: '',
            complement: '',
            days: '',
            hours: '',
            name: ''
        }
    )

    const getCep = async (cep: string) => {
        //.slice(0,5) + '-' + freight?.cep.slice(5)}
        let cepFormated = ''
        let url = ''
        if (cep.length === 8 && /^[0-9]+$/.test(cep)) {

            url = `https://viacep.com.br/ws/${cep}/json/`;

            const response = await axios.get(url);
            const data = response.data

            cepFormated = cep.slice(0, 5) + '-' + cep.slice(5)



            setFormData((prevData) => ({
                ...prevData,
                cep: cepFormated,
                street: data.logradouro,
                state: data.uf,
                city: data.localidade,
                neighborhood: data.bairro,
            }))
        } else {
            setFormData((prevData) => ({
                ...prevData,
                cep: cep.replace('-', ''),
                street: '',
                state: '',
                city: '',
                neighborhood: '',
            }))
        }




    }

    const close = () => {
        setModalActive(false);
    }

    const handleDataChange = (field: string, value: any) => {

        setFormData((prevData) => ({
            ...prevData,
            [field]: value
        }))

    }

    return (
        <Container>
            <HeaderDiv style={{ gridArea: `titleNew` }}>
                <HeaderText>{'Novo Cliente'}</HeaderText>
                <CloseDiv onClick={() => close()} >
                    <CloseImg src={cross} alt='Close tab' />
                </CloseDiv>
            </HeaderDiv>
            <GridContainer>
                {
                    elementsCEP.map((element, index) => (
                        <>
                            <InputDiv style={{ gridArea: element.field }}>
                                <InputLabel>{element.label}</InputLabel>
                                <Input value={formData[element.field]} type={element.type}
                                    maxLength={element.field === 'cep' ? 9 : 300}
                                    onChange={(e) => {

                                        if (element.editable) {
                                            handleDataChange(element.field, e.target.value)

                                            if (element.field === 'cep') {
                                                getCep(e.target.value)
                                            }
                                        }
                                    }} placeholder="Digite aqui">
                                </Input>
                            </InputDiv>
                        </>
                    ))
                }
                <LineDiv></LineDiv>
            </GridContainer>
            <OptionsDiv>

                <ButtonOfSection className="reverse" onClick={() => close()}>
                    <ButtonOfSectionText className="reverse">Cancelar</ButtonOfSectionText>
                </ButtonOfSection>

                <ButtonOfSection>
                    <IconImg src={plus}></IconImg>
                    <ButtonOfSectionText>Salvar</ButtonOfSectionText>
                </ButtonOfSection>

            </OptionsDiv>
        </Container>
    )
}

export default ClientForm
